import React from "react";
import {
  Caption1,
  Card,
  List,
  ListItem,
  Subtitle2,
  Text,
} from "@fluentui/react-components";
import {
  Button,
  DrawerBody,
  DrawerHeader,
  DrawerHeaderTitle,
  OverlayDrawer,
  useRestoreFocusSource,
} from "@fluentui/react-components";
import { Building20Filled, Dismiss24Regular } from "@fluentui/react-icons";
import { useProspectionDrawerStyles } from "../index.styles";
import {
  AtividadePrincipal,
  ProspectionDrawerState,
  Qsa,
} from "../index.types";
import moment from "moment";
import {
  Lawsuit,
  PerdcompSituacao,
  PerdcompTipoDocumento,
  PerDecomp,
} from "types/OnDemand.types";
import { useSearchPerdecompSummary } from "hooks/PerDecomp/usePerdcompSummary";
import { DownloadFileButton } from "Components/CreateFileRender";
import { useSearchProcessesSummary } from "hooks/ProcessosJudiciais/useProcessesSummary";
import { number } from "zod";

export const ProspectionDrawer = (state: ProspectionDrawerState) => {
  const styles = useProspectionDrawerStyles();
  const { isOpen, setIsOpen, setIsFalse } = state;
  const {
    selectedProspect: { processes, perdcomp, regimeTributario },
  } = state;
  const company = state.selectedProspect;

  const atividades = JSON.parse(
    company.atividadePrincipal,
  ) as AtividadePrincipal[];
  const qsa = JSON.parse(company.qsa) as Qsa[];

  const restoreFocusSourceAttributes = useRestoreFocusSource();
  const perdcompSummary = useSearchPerdecompSummary(perdcomp);
  const processesSumary = useSearchProcessesSummary(processes);
  if (company) console.log(company);
  return (
    <OverlayDrawer
      {...restoreFocusSourceAttributes}
      open={isOpen}
      position="end"
      onOpenChange={(_, state) => setIsOpen(state.open)}
      className={styles.overlayDrawer}
    >
      <DrawerHeader>
        <DrawerHeaderTitle
          className={styles.header}
          action={
            <Button
              appearance="subtle"
              aria-label="Close"
              icon={<Dismiss24Regular />}
              onClick={() => setIsFalse(false)}
            />
          }
        >
          <Building20Filled style={{ verticalAlign: "text-bottom" }} />
          {company.cnpj}
        </DrawerHeaderTitle>
        <Caption1>
          Pesquisado em {moment(company.createdAt).format("DD/MM/YYYY HH:mm")}
        </Caption1>
        <Caption1>
          Atualizado em {moment(company.updateOn).format("DD/MM/YYYY HH:mm")}
        </Caption1>
      </DrawerHeader>

      <DrawerBody className={styles.body}>
        <List navigationMode="items">
          <ListItem className={styles.listItem}>
            <Card className={styles.listCard}>
              <Subtitle2>INFORMACOES BASICAS</Subtitle2>
              <Text weight="bold">Nome Fantasia: &nbsp;</Text>
              {company.nome}&nbsp;&nbsp;&nbsp;
              <div>
                <Text weight="bold">Municipio: &nbsp;</Text>
                {company.municipio}&nbsp;&nbsp;&nbsp;
                <Text weight="bold">UF: &nbsp;</Text>
                {company.uf}&nbsp;&nbsp;
                <Text weight="bold">Telefone: &nbsp;</Text>
                {company.telefone}
              </div>
              <div>
                <Text weight="bold">Regime tributário:&nbsp;</Text>
                {regimeTributario?.formaDeTributacao ?? "NAO ENCONTRADO"} &nbsp;
                <Text weight="bold">Ano:&nbsp;</Text>
                {regimeTributario?.ano ?? ""}
              </div>
              <div>
                <Text weight="bold">Tipo:&nbsp;</Text>
                {company?.tipo ?? ""}&nbsp;
                <Text weight="bold">Porte:&nbsp;</Text>
                {company?.porte ?? ""}
              </div>
              <div>
                <Text weight="bold">Abertura:&nbsp;</Text>
                {moment(company?.abertura).format("DD/MM/YYYY") ?? ""}&nbsp;
                <Text weight="bold">Situacao:&nbsp;</Text>
                {company?.situacao ?? ""}&nbsp;
              </div>
              <div>
                <Text weight="bold">Capital Social:&nbsp;</Text>
                {company.capitalSocial ?? ""}&nbsp;
                {/* <Text weight="bold">Situacao:&nbsp;</Text> */}
                {/* {company?.situacao ?? ""}&nbsp; */}
              </div>
              <div>
                <Text weight="bold">Atividade Principal:&nbsp;</Text>
                <div>{atividades.map((a) => `${a.text} - ${a.code}`)}</div>
              </div>
            </Card>
          </ListItem>
          <ListItem className={styles.listItem}>
            <Card className={styles.listCard}>
              <Subtitle2>QSA </Subtitle2>
              {qsa.map((a) => (
                <div>
                  &nbsp;
                  <div>
                    <Text weight="bold">Nome:&nbsp;</Text>
                    {a.nome}
                  </div>
                  <div>
                    <Text weight="bold">QUAL:&nbsp;</Text>
                    {a.qual}
                  </div>
                </div>
              ))}
            </Card>
          </ListItem>
          <ListItem className={styles.listItem}>
            <Card className={styles.listCard}>
              <Subtitle2>
                PERDCOMP{" "}
                <DownloadFileButton<PerDecomp>
                  cnpj={company.cnpj}
                  companyName={company.nome}
                  dataset="perdcomp"
                  items={perdcomp}
                />
              </Subtitle2>
              <Text>
                <span style={{ fontWeight: "bold" }}>
                  Total (Ped. restituicao):&nbsp;
                </span>
                {perdcompSummary.valid.length}
              </Text>
              <div>
                <Text>
                  <span style={{ fontWeight: "bold" }}>IPI: &nbsp;</span>
                  {perdcompSummary.ipi.length}
                </Text>
                <Text style={{ marginLeft: "10px" }}>
                  <span style={{ fontWeight: "bold" }}>PIS: &nbsp;</span>
                  {perdcompSummary.pis.length}
                </Text>
              </div>
              <Text>
                <span style={{ fontWeight: "bold" }}>CONFINS&nbsp;</span>
                {perdcompSummary.confins.length}
              </Text>
              <Text>
                <span style={{ fontWeight: "bold" }}>SN IRPJ&nbsp;</span>
                {perdcompSummary.snirpj.length}
              </Text>
              <Text>
                <span style={{ fontWeight: "bold" }}>SN CSLL&nbsp;</span>
                {perdcompSummary.sncsll.length}
              </Text>
              <Text>
                <span style={{ fontWeight: "bold" }}>SN REIntegra</span>
              </Text>
              <Text>
                <span style={{ fontWeight: "bold" }}>
                  Pagamento indevido ou a maior: &nbsp;
                </span>
                {perdcompSummary.pagementoMaiorIndevido.length}
              </Text>
              <Text>
                <span style={{ fontWeight: "bold" }}>
                  Salario-familia / salario maternidade &nbsp;
                </span>
                {perdcompSummary.salarioFamiliaMaternidade.length}
              </Text>
            </Card>
          </ListItem>
          <ListItem className={styles.listItem}>
            <Card className={styles.listCard}>
              <Subtitle2>
                PROCESSOS JUDICIAIS{" "}
                <DownloadFileButton<Lawsuit>
                  cnpj={company.cnpj}
                  companyName={company.nome}
                  dataset="perdcomp"
                  items={processes}
                />
              </Subtitle2>
              <Text>
                <span style={{ fontWeight: "bold" }}>Total processos: </span>
                {processesSumary.valid.length}
              </Text>
            </Card>
          </ListItem>

          {/* <ListItem className={styles.listItem}>
            <Text weight="bold">Atividade Principal:&nbsp;</Text>
            {company.atividade_principal.map((e) => `${e.code} - ${e.text}`)}
          </ListItem> */}
          {/* 
            https://github.com/zerma-verse/nin-ux/issues/17
            
            <ListItem className={styles.listItem}>
            <Text weight="bold">Oportunidade CNAE:&nbsp;</Text>ISS produtoras;
            Perse; Reforma Tributaria
          </ListItem> */}
        </List>
      </DrawerBody>
    </OverlayDrawer>
  );
};
